import React from 'react'

// Shown on the drill-down pages (traces / errors) when a núcleo is looking at an associated company's
// data, so it is always clear whose events are on screen - reprocessing acts on that company.
// Renders nothing for the logged company's own data.
const ViewingCompanyChip = ({ company }) => {
  if (!company) return null

  const name = company.nome_fantasia || company.razao_social
  return (
    <span
      title={company.nome_fantasia ? `${company.nome_fantasia} - ${company.razao_social}` : company.razao_social}
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full border border-purple-200 dark:border-purple-800 bg-purple-50 dark:bg-purple-900/20 max-w-[260px] flex-shrink-0"
    >
      <span className="material-icons text-purple-600 dark:text-purple-300" style={{ fontSize: '14px' }}>apartment</span>
      <span className="w-px h-3 bg-purple-200 dark:bg-purple-800" />
      <span className="text-xs font-mono font-medium tracking-wide text-purple-700 dark:text-purple-300 truncate">{name}</span>
    </span>
  )
}

export default ViewingCompanyChip
